import { DomainContext } from '../../changes/DomainContext';
import { StaleReferenceError } from '../../errors/DomainError';
import { Patient } from '../../patient/patient';
import { Roi } from '../../patient/roi';
import { RoiRef } from './RoiService';
import { domainTrace } from '../../diagnostics/domainTrace';

export type SliceIndex = number;

export class ContourService {
    constructor(
        private readonly context: DomainContext,
        private readonly patient: Patient
    ) {}

    commitContourEdit(ref: RoiRef, _modifiedSlices: SliceIndex[]): void {
        domainTrace.service('ContourService.commitContourEdit', {
            id: ref.id,
            sliceCount: _modifiedSlices.length,
        });
        this.context.tracker.command(() =>
            this.resolve(ref).markContourEdited()
        );
    }

    commitContourRevert(ref: RoiRef): void {
        domainTrace.service('ContourService.commitContourRevert', {
            id: ref.id,
        });
        this.context.tracker.command(() =>
            this.resolve(ref).markContourReverted()
        );
    }

    private resolve(ref: RoiRef): Roi {
        for (const ss of this.patient.structureSets) {
            const roi = ss.getRoiById(ref.id);
            if (roi) {
                return roi;
            }
        }
        throw new StaleReferenceError(`Roi ${ref.id} no longer exists.`);
    }
}
